import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext.jsx";
import Layout from "./components/Layout.jsx";
import LoadingSpinner from "./components/LoadingSpinner.jsx";
import RequireAdmin from "./components/RequireAdmin.jsx";
import Login from "./pages/Login.jsx";
import ResetPassword from "./pages/ResetPassword.jsx";
import Dashboard from "./pages/Dashboard.jsx";
import Booking from "./pages/Booking.jsx";
import MyBookings from "./pages/MyBookings.jsx";
import AdminUsers from "./pages/admin/AdminUsers.jsx";
import AdminResources from "./pages/admin/AdminResources.jsx";
import AdminBookings from "./pages/admin/AdminBookings.jsx";
import AdminIntegrations from "./pages/admin/AdminIntegrations.jsx";
import SeedDesks from "./pages/admin/SeedDesks.jsx";
import { BOOKING_BASE } from "./constants.js";

function Protected({ user, children }) {
  if (!user) return <Navigate to={`${BOOKING_BASE}/login`} replace />;
  return children;
}

export default function BookingAppRoutes() {
  const { user, loading } = useAuth();

  if (loading) return <LoadingSpinner />;

  return (
    <Routes>
      <Route
        path="login"
        element={user ? <Navigate to={BOOKING_BASE} replace /> : <Login />}
      />
      <Route
        path="reset-password"
        element={user ? <Navigate to={BOOKING_BASE} replace /> : <ResetPassword />}
      />
      <Route
        path="*"
        element={
          <Protected user={user}>
            <Layout>
              <Routes>
                <Route index element={<Dashboard />} />
                <Route path="booking" element={<Booking />} />
                <Route path="my-bookings" element={<MyBookings />} />
                <Route
                  path="admin/users"
                  element={
                    <RequireAdmin>
                      <AdminUsers />
                    </RequireAdmin>
                  }
                />
                <Route
                  path="admin/bookings"
                  element={
                    <RequireAdmin>
                      <AdminBookings />
                    </RequireAdmin>
                  }
                />
                <Route
                  path="admin/integrations"
                  element={
                    <RequireAdmin>
                      <AdminIntegrations />
                    </RequireAdmin>
                  }
                />
                <Route
                  path="admin/resources"
                  element={
                    <RequireAdmin>
                      <AdminResources />
                    </RequireAdmin>
                  }
                />
                <Route
                  path="admin/seed-desks"
                  element={
                    <RequireAdmin>
                      <SeedDesks />
                    </RequireAdmin>
                  }
                />
                <Route
                  path="admin/reports"
                  element={<Navigate to={`${BOOKING_BASE}/admin/bookings`} replace />}
                />
                <Route path="*" element={<Navigate to={BOOKING_BASE} replace />} />
              </Routes>
            </Layout>
          </Protected>
        }
      />
    </Routes>
  );
}
